import { theme } from '@focaldata/cin-ui-components'
import { useContext } from 'react'
import LanguageSelect from '../../controls/LanguageSelect'
import { useAudienceDisplayLanguage } from '../../hooks/audience/useAudienceDisplayLanguage'
import { useMarketLanguages } from '../../hooks/audience/useMarketLanguages'
import AudienceContext, { setAudienceDisplayLanguage } from './Audience.context'

// Horizontal inset matches the completes / survey-stats subheader above it
// (Subheader with leftRightPadding=false → theme.spacing(4)), so the control
// lines up with that row instead of hugging the builder's left edge.
const PADDING = theme.spacing(1.5, 4)

/**
 * Language switch for the audience builder. Only shown for genuinely
 * multi-language markets (2+ allocated languages); it lets the researcher view
 * the builder's question/option text in any of the market's languages (plus the
 * English master), defaulting to the market's primary language. Display-only —
 * it never changes the survey's language allocations, and its selection resets
 * to the primary when switching markets (the editor remounts per market).
 */
export const AudienceLanguageSwitch = () => {
  const { dispatch } = useContext(AudienceContext)
  const { languages, isMultiLanguage } = useMarketLanguages()
  // Resolves to the market's primary language when nothing (or a no-longer-valid
  // language) is selected, so the control's value always matches an option.
  const selected = useAudienceDisplayLanguage()

  // Stricter than LanguageSelect's own guard: `languages` always carries the
  // English master, so a single-language German market offers two codes while
  // having nothing worth switching.
  if (!isMultiLanguage) return null

  return (
    <LanguageSelect
      languages={languages}
      selectedLanguage={selected}
      onLanguageChange={(language) =>
        dispatch(setAudienceDisplayLanguage(language))
      }
      ariaLabel="Audience builder language"
      padding={PADDING}
    />
  )
}

export default AudienceLanguageSwitch
